import { render, staticRenderFns } from "./dialog-bh-type.vue?vue&type=template&id=3727f37c&scoped=true&"
import script from "./dialog-bh-type.vue?vue&type=script&lang=js&"
export * from "./dialog-bh-type.vue?vue&type=script&lang=js&"
import style0 from "./dialog-bh-type.vue?vue&type=style&index=0&id=3727f37c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3727f37c",
  null
  
)

export default component.exports